module.exports = __webpack_public_path__ + "static/shapes-1-ba4eb7d33b999c6dc1b491cae658b321.gif";